import React, { useEffect, useState } from 'react';
import { Anchor, Box, DataTable, Heading, Pagination } from 'grommet';
import QueryString from 'qs';
import { API, Utils } from '@enrich/shared-lib';

export const PipelineReporting = () => {
    const stepOptions = [25, 50, 100];
    const [pipelines, setPipelines] = useState([]);
    const [page, setPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [pageSize, setPageSize] = useState(stepOptions[0]);

    useEffect(() => {
        if (!page) return;
        let isActive = true;

        (async () => {
            const pipelinesResponse = await loadPipelines({ page, pageSize });

            if (isActive) {
                setPage(pipelinesResponse.meta.pagination.page);
                setPipelines(Utils.deepFlatten(pipelinesResponse.data));
                setTotalItems(pipelinesResponse.meta.pagination.total);
            }
        })();

        return () => {
            isActive = false;
        };
    }, [page, pageSize]);

    const handlePageChange = ({ page, startIndex, endIndex }) => {
        const newPageSize = endIndex - startIndex;
        if (pageSize != newPageSize) {
            setPageSize(newPageSize);
        }
        setPage(page);
    };

    const dataColumns = [
        {
            header: 'Name',
            property: 'name',
            render: (pipeline) => {
                return (
                    <Anchor
                        key={pipeline.id}
                        href={`/pipelines/${pipeline.id}`}
                        label={pipeline.name}
                    />
                );
            },
            sortable: true,
        },
        {
            header: 'Company',
            property: 'company.name',
            render: (pipeline) => {
                if (!pipeline.company) return null;

                return (
                    <Anchor
                        key={pipeline.company.id}
                        href={`/companies/${pipeline.company.id}`}
                        label={pipeline.company.name}
                    />
                );
            },
            sortable: true,
        },
    ];

    return (
        <Box>
            <Heading level="3">Pipelines</Heading>
            <DataTable
                primaryKey="id"
                sortable
                border="bottom"
                data={pipelines}
                columns={dataColumns}
            />
            <Box align="center" justify="center" pad="small">
                <Pagination
                    numberItems={totalItems}
                    onChange={({ page, startIndex, endIndex }) => {
                        handlePageChange({
                            page,
                            startIndex,
                            endIndex,
                        });
                    }}
                    step={pageSize}
                    stepOptions={stepOptions}
                    summary={true}
                />
            </Box>
        </Box>
    );
};

const loadPipelines = async ({ page, pageSize } = {}) => {
    const query = QueryString.stringify({
        filters: {
            isReportingActive: true,
        },
        populate: {
            company: {
                fields: ['id', 'name'],
            },
        },
        pagination: page && pageSize ? { page, pageSize } : undefined,
        sort: ['updatedAt:desc'],
    });

    try {
        const response = await API.get(`/api/pipelines?${query}`);
        return response.data;
    } catch (error) {
        console.log(error);
    }

    return [];
};
